import { DefaultBlock, DefaultBlockResource } from '../../Block/Block';

export enum FormTypeResource {
    contact = 'Contact',
    participate = 'Deelnemen bij Loods 5',
}

export interface FormResource extends DefaultBlockResource {
    title?: string;
    infoOrTerms?: string;
    type?: FormTypeResource;
}

export enum FormType {
    contact = 'contact',
    participate = 'participate',
}

export interface FormInterface extends DefaultBlock {
    title: string;
    formType: FormType;
    information?: string;
}
